module.exports = __webpack_public_path__ + "img/iocn8.3c1a042e.png";